const firebaseConfig = {
    apiKey: "AIzaSyCa7-LrsixESkaz3nFBWOpUJP91x0t2byQ",
    authDomain: "chittagong-dental-care.firebaseapp.com",
    projectId: "chittagong-dental-care",
    storageBucket: "chittagong-dental-care.appspot.com",
    messagingSenderId: "588207534318",
    appId: "1:588207534318:web:103594b53124f1356b43ff"
  };

export default firebaseConfig;